import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod";

export const getLatestOpenFulfillmentGroup = {
  name: "getLatestOpenFulfillmentGroup" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    requestSource: z.literal("scan").nullish(),
  }),
  output: z.object({
    fulfillmentGroup: FulfillmentGroupDataSchema,
    originalGroupWasMerged: z.boolean().nullish(),
  }),
};
